// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","first-table-shrink-width":"1050px","buttonsContainer":"LostDamagedPalletsStepFooter_buttonsContainer__JQPGW"};